import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/common.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private baseUrl = environment.baseUrlAdmin;

  constructor(private http: HttpClient) { }

  public getProductSummary(productId, isBiz = false): Observable<any> {
    return this.http.post(`${this.baseUrl}getProductSummary`, { productId, isBiz })
  }

  public getMemberShopProductList(payload: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${this.baseUrl}community/product-list-for-marketplace`,
      payload
    );
  }

  public getTopCategoryProducts(payload): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${this.baseUrl}community/top-category-products`,
      payload
    );
  }

  public getTgBotRegistration() {
    return this.http.get(`${this.baseUrl}getTgBotRegistration`);
  }
  public registerTgBot(tgToken) {
    return this.http.post(`${this.baseUrl}registerTgBot`, {
      tgToken,
    });
  }

  public getProfileInfo(user = null, isReferral = false, forceID = false): Observable<any> {
    if (user) {
      return this.http.get(`${this.baseUrl}getProfileInfo${forceID ? '?forceID=1' : ''}`, {
        params: {
          [`${isReferral ? 'referralCode' : 'user'}`]: user,
        },
      });
    } else {
      return this.http.get(`${this.baseUrl}getProfileInfo`);
    }
  }

  public getProfileMatrix(userId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}getProfileMatrix?userId=${userId}`);
  }

  public getBizProfiles(): Observable<any> {
    return this.http.get(`${this.baseUrl}getBizProfiles`);
  }

  //  *** Notification ***
  public getAllNotificationsForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllNotificationsForMember`);
  }

  public popularMemberShopKeyword(isAdmin = 0): Observable<any> {
    return this.http.get(
      `${this.baseUrl}membershop-keywords-popular?isAdmin=${isAdmin}`
    );
  }

  public popularMemberShopKeywordChangeStatus(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}membershop-keywords-popular-change`,
      payload
    );
  }

  public getCharacterListForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getCharacterListForMember`);
  }

  public getShopStatus(): Observable<any> {
    return this.http.get(`${this.baseUrl}getShopStatus`);
  }

  public getMemberShopsProfile(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberShopsProfile`);
  }

  public getAllShopProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getAllShopProduct`, payload);
  }

  public getFavoriteProducts(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getFavoriteProducts`, payload);
  }

  public getMemberShopsProfileById(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getMemberShopsProfileById`, payload);
  }

  public getRolesForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getRolesForMember`);
  }

  public removeCard(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}removeCard`, payload);
  }

  public saveMemberEmail(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}saveMemberEmail`, payload);
  }
  public verifyEmailOtp(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}verifyEmailOtp`, payload);
  }

  public getOnlineMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getOnlineMember`);
  }

  public setProfileToDefault(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}setProfileToDefault`, payload);
  }

  public getSupported(): Observable<any> {
    return this.http.get(`${this.baseUrl}getSupported`);
  }

  public hideMemberShopAsk(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}hideMemberShopAsk`, payload);
  }

  public updateUserMuteStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateUserMuteStatus`, payload);
  }

  public updateUserBlockStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateUserBlockStatus`, payload);
  }

  public deleteUser(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}deleteUser`, payload);
  }

  public getReferralUsers(
    page: number = 1,
    limit: number = 10
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getReferralUsers?page=${page}&limit=${limit}`
    );
  }

  public changeClaimStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}changeClaimStatus`, payload);
  }

  public getSurveyResponses(): Observable<any> {
    return this.http.get(`${this.baseUrl}getSurveyResponses`);
  }

  public updateTag(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateTag`, payload);
  }

  // JobPost
  public addMemberJobPost(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberJobPost`, payload);
  }

  public deleteMemberJobPost(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberJobPost/${id}`);
  }

  public getMemberJobPost(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberJobPost`);
  }

  public getAllJobPost(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberJobPost`);
  }

  // JobPost

  public login(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}login-member`, payload);
  }

  public galleryLikes(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}galleryLikes`, payload);
  }

  public userGallery(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}userGallery`, {
      params: payload,
    });
  }
  public userExperiences(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}userExperiences`, {
      params: payload,
    });
  }

  public getBizByRegion(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getBizByRegion`, payload);
  }

  public getBizProductList(filter: any): Observable<any> {
    return this.http.get(this.baseUrl + `marketplace_food_listing`, {
      params: filter,
    });
  }

  public getBizCategories(): Observable<any> {
    return this.http.get(this.baseUrl + `marketplace_categories`);
  }

  public getBizBrandList(): Observable<any> {
    return this.http.get(`${this.baseUrl}brands`);
  }

  public getAllCommunityProductCategoryList(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllCategoriesList`);
  }

  public getBizShopBanner(adminId) {
    return this.http.get(this.baseUrl + `get_all_product_banner/${adminId}`);
  };

  public jobPostView(id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}jobPostView?id=` + id);
  }

  public addMemberSupport(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addmemberSupport`, payload);
  }

  public deleteMemberSupport(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberSupport/${id}`);
  }

  public getUserSupportList(): Observable<any> {
    return this.http.get(`${this.baseUrl}getUserSupportList`);
  }

  public deleteReportProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}deleteReportProduct`, payload);
  }

  public getSchema(type: string) {
    return this.http.get(`${this.baseUrl}meta/schema/get`, {
      params: {
        type: type
      }
    });
  }
}
